import { Box } from '@twilio-paste/core/box';

import { ViewErrorState } from '../ViewErrorState';

export function FormDrawerErrorState() {
  return (
    <Box margin="space100">
      <ViewErrorState />
    </Box>
  );
}
